import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

const ROLE_RANK = { subscriber: 0, editor: 1, dev: 2 };

function roleAtLeast(userRole, requiredRole) {
  const u = ROLE_RANK[userRole];
  const r = ROLE_RANK[requiredRole];
  if (u === undefined || r === undefined) return false;
  return u >= r;
}

export default function ProtectedRoute({ role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24 text-hxd-muted text-sm">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (role && !roleAtLeast(user.role, role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
